import { convertToDateWithLocale, formatDateFieldInput, formatDisplayDate } from '@/helpers';
import {
  BaseEntityDTO,
  IBaseEntityDTO,
  IOrderDTO,
  IProductAdditionDTO,
  IProductDTO,
  OrderDTO,
  ProductDTO,
} from './';
import { ProductAdditionDTO } from './product.addition.dto';

export interface IProductVariantDTO extends IBaseEntityDTO {
  description: string;
  price: number;
  start_date?: Date;
  end_date?: Date;
  productAdditions: IProductAdditionDTO[];
  orders: IOrderDTO[];
  fieldInputStartDate: string;
  displayStartDate: string;
  fieldInputEndDate: string;
  displayEndDate: string;
  product: IProductDTO;
}
export class ProductVariantDTO extends BaseEntityDTO implements IProductVariantDTO {
  description: string;
  price: number;
  start_date?: Date;
  end_date?: Date;
  productAdditions: IProductAdditionDTO[];
  orders: IOrderDTO[];
  product: IProductDTO;

  constructor(data?: Partial<ProductVariantDTO>) {
    super(data);
    this.description = data?.description ?? '';
    this.price = data?.price ?? 0.0;
    this.start_date = data?.start_date ?? undefined;
    this.end_date = data?.end_date ?? undefined;
    this.productAdditions = data?.productAdditions
      ? data.productAdditions.map((addition) => new ProductAdditionDTO(addition))
      : [];
    this.orders = data?.orders ? data.orders.map((order) => new OrderDTO(order)) : [];

    this.product = new ProductDTO(data?.product);
  }

  /** EXTENDED Properties **/
  get fieldInputStartDate(): string {
    return this.start_date ? formatDateFieldInput(this.start_date) : '';
  }

  set fieldInputStartDate(value: string) {
    this.start_date = convertToDateWithLocale(value);
  }

  get displayStartDate(): string {
    return this.start_date ? formatDisplayDate(this.start_date) : '';
  }

  get fieldInputEndDate(): string {
    return this.end_date ? formatDateFieldInput(this.end_date) : '';
  }

  set fieldInputEndDate(value: string) {
    this.end_date = convertToDateWithLocale(value);
  }

  get displayEndDate(): string {
    return this.end_date ? formatDisplayDate(this.end_date) : '';
  }
}
